import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as basketActions } from 'src/redux/basket/slice';
import { selectIsInStock } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { ReduxApplicationState } from 'src/redux/types';
import type { ProductOptionsDispatchProps, ProductOptionsStateProps } from './ProductOptions';

type UseProductOptions = ProductOptionsDispatchProps & ProductOptionsStateProps;

export const useProductOptions = (): UseProductOptions => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const inStock = useSelector(selectIsInStock);
  const quantity = useSelector((state: ReduxApplicationState) => state.basket.quantity);

  const onChangeQuantity = useCallback(
    ({ quantity, valid }: { quantity: number; valid: boolean }) => {
      dispatch(basketActions.changeQuantity({ isValid: valid, quantity }));
    },
    [dispatch],
  );

  return {
    inStock,
    onChangeQuantity,
    quantity,
  };
};
